import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/reception',
    name: 'reception',
    component: () => import(/* webpackChunkName: "reception" */ '../views/ReceptionView.vue')
  },
  {
    path: '/antho/:patient_uuid',
    name: 'antho',
    component: () => import(/* webpackChunkName: "antho" */ '../views/AnthoView.vue')
  },
  {
    path: '/reception/newvisit/:patient_uuid',
    name: 'patientnewvisit',
    component: () => import(/* webpackChunkName: "patientnewvisit" */ '../views/ReceptionNewVisitView.vue')
  },
  {
    path: '/doctors/:patient_uuid?',
    name: 'doctors',
    component: () => import(/* webpackChunkName: "doctors" */ '../views/DoctorsView.vue')
  },
  {
    path: '/lab/:patient_uuid?',
    name: 'lab',
    component: () => import(/* webpackChunkName: "lab" */ '../views/LabView.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/DashboardView.vue')
  },
  {
    path: '/search/:department?',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/SearchView.vue')
  },
  {
    path: '/advance-search',
    name: 'advance_search',
    component: () => import(/* webpackChunkName: "advance_search" */ '../views/AdvanceSearchView.vue')
  },
  {
    path: '/pharmacy/:patient_uuid?',
    name: 'pharmacy',
    component: () => import(/* webpackChunkName: "pharmacy" */ '../views/PharmacyView.vue')
  },
  {
    path: '/viewpanels/:patient_uuid/:patient_history_uuid?',
    name: 'viewpanels',
    component: () => import(/* webpackChunkName: "viewpanels" */ '../views/ViewPanels.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/permissions',
    name: 'permissions',
    component: () => import(/* webpackChunkName: "permissions" */ '../views/PermissionsView.vue')
  },
  {
    path: '/lab-management',
    name: 'lab_management',
    component: () => import(/* webpackChunkName: "lab_management" */ '../views/LabManagementView.vue')
  },
  {
    path: '/lab-sampling/:patient_uuid',
    name: 'lab_sampling',
    component: () => import(/* webpackChunkName: "lab_sampling" */ '../views/LabSamplingView.vue')
  },
  {
    path: '/lab-results/:patient_uuid',
    name: 'lab_results',
    component: () => import(/* webpackChunkName: "lab_results" */ '../views/LabResultsView.vue')
  },
  {
    path: '/inventory-management',
    name: 'inventory_management',
    component: () => import(/* webpackChunkName: "inventory_management" */ '../views/InventoryManagementView.vue')
  },
  {
    path: '/new-input-doc',
    name: 'new_input_doc',
    component: () => import(/* webpackChunkName: "new_input_doc" */ '../views/NewInputDocument.vue')
  },
  {
    path: '/new-output-doc',
    name: 'new_output_doc',
    component: () => import(/* webpackChunkName: "new_output_doc" */ '../views/NewOutputDocument.vue')
  },
  {
    path: '/log-activities',
    name: 'log_activities',
    component: () => import(/* webpackChunkName: "log_activities" */ '../views/LogActivitiesView.vue')
  },
  {
    path: '/users-management',
    name: 'users_management',
    component: () => import(/* webpackChunkName: "users_management" */ '../views/UsersManagementView.vue')
  },
  {
    path: '/patients-management',
    name: 'patients_management',
    component: () => import(/* webpackChunkName: "patients_management" */ '../views/PatientsManagementView.vue')
  },
  {
    path: '/diagnosis-management',
    name: 'diagnosis_management',
    component: () => import(/* webpackChunkName: "diagnosis_management" */ '../views/DiagnosisManagementView.vue')
  },
  {
    path: '/symptoms-management',
    name: 'symptoms_management',
    component: () => import(/* webpackChunkName: "symptoms_management" */ '../views/SymptomsManagementView.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ '../views/SettingsView.vue')
  },
  {
    path: '/pharmacy-management',
    name: 'pharmacy-management',
    component: () => import(/* webpackChunkName: "management" */ '../views/PharmacyManagementView.vue')
  },
  {
    path: '/providers-management',
    name: 'providers-management',
    component: () => import(/* webpackChunkName: "management" */ '../views/ProvidersView.vue')
  },
  {
    path: '/drug-management',
    name: 'drug-management',
    component: () => import(/* webpackChunkName: "management" */ '../views/DrugsManagementView.vue')
  },
  {
    path: '/committee-approval',
    name: 'committee-approval',
    component: () => import(/* webpackChunkName: "committee" */ '../views/CommitteeApprovalView.vue')
  },
  {
    path: '/committee-approval-confirm/:patient_history_uuid',
    name: 'committee-approval-confirm',
    component: () => import(/* webpackChunkName: "committee-approval-confirm" */ '../views/CommitteeApprovalConfirmView.vue')
  },
  {
    path: '/modify-patient-info/:patient_uuid',
    name: 'modify-patient-info',
    component: () => import(/* webpackChunkName: "modify-patient-info" */ '../views/ModifyPatientInfo.vue')
  },
  {
    path: '/edit-input-document/:doc_id',
    name: 'edit-input-document',
    component: () => import(/* webpackChunkName: "edit-input-document" */ '../views/editInputDocument.vue')
  },
  {
    path: '/edit-output-document/:doc_id',
    name: 'edit-output-document',
    component: () => import(/* webpackChunkName: "edit-output-document" */ '../views/editOutputDocument.vue')
  },
  {
    path: '/antho-history/:patient_history_uuid',
    name: 'antho-history',
    component: () => import(/* webpackChunkName: "antho-history" */ '../views/AnthoHistoryView.vue')
  },
  {
    path: '/doctor-history/:patient_history_uuid',
    name: 'doctor-history',
    component: () => import(/* webpackChunkName: "doctor-history" */ '../views/DoctorHistoryView.vue')
  },
  {
    path: '/lab-history/:patient_history_uuid',
    name: 'lab-history',
    component: () => import(/* webpackChunkName: "lab-history" */ '../views/LabHistoryView.vue')
  },
  {
    path: "/advanced/search",
    name: "advanced-search",
    component: () => import("../views/AdvancedSearchView.vue"),
  },
  {
    path: "/advanced/result",
    name: "advanced-result",
    props: true,
    component: () => import("../views/SearchResultView.vue"),
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
